var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AccountRoutesType } from "../../../Shared/components/Navigation/navigationUtils";
import { OpenBalanceTexts } from "./openBalance-enums";
import { processPayment } from "./openBalancePage-requests";
/**
 * Redirects the user to the Orders page.
 * @param navigate - The navigation function from react-router.
 */
export const redirectToOrders = (navigate) => {
    navigate(AccountRoutesType.ORDERS, { replace: true });
};
/**
 * Returns the appropriate replacement text based on the countdown value.
 * @param countdown - The countdown value in seconds.
 * @returns A string representing the countdown text.
 */
export const getReplacementText = (countdown) => {
    if (countdown === 1)
        return OpenBalanceTexts.ONE_SECOND;
    return `${countdown} ${OpenBalanceTexts.SECONDS}`;
};
/**
 * Handles the click event for the cancel button.
 * Redirects the user to the Orders page.
 * @param navigate - The navigation function from react-router.
 * @returns A function to handle the cancel button click.
 */
export const cancelButtonOnClick = (navigate) => () => {
    navigate(AccountRoutesType.ORDERS, { replace: true });
};
/**
 * Submits a payment request and handles the result.
 * Displays a success or failure toast based on the payment result.
 * @param param0 - The payment request parameters and additional state handlers.
 * @returns An async function to handle the payment submission.
 */
export const submitPayment = ({ amount, giftCardId, idempotencyKey, orderId, paymentIntentId, paymentMethodId, paymentNote, paymentProcessor, setIsLoading, setPaymentComplete, toast, resetBillingInfoContext, }) => () => __awaiter(void 0, void 0, void 0, function* () {
    setIsLoading(true);
    try {
        // Process the payment request
        const results = yield processPayment({
            amount,
            giftCardId,
            idempotencyKey: idempotencyKey !== null && idempotencyKey !== void 0 ? idempotencyKey : undefined,
            orderId,
            paymentMethodId,
            paymentNote,
            paymentIntentId,
            paymentProcessor,
        });
        // Handle the result of the payment
        if (results === null || results === void 0 ? void 0 : results.success) {
            setPaymentComplete(true);
            toast.push(OpenBalanceTexts.SUCCESS_TOAST, { variant: "success" });
        }
        else {
            toast.push(OpenBalanceTexts.FAILURE_TOAST, { variant: "error" });
        }
    }
    finally {
        // Reset the billing information context
        resetBillingInfoContext();
        // Ensure loading state is reset
        setIsLoading(false);
    }
});
